import groq from 'groq';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';
export const blockBaseTextFields = groq`
  text[] {
  ${portableTextWithReferences},
  tableData {
      ...,
      rows[] {
        ...,
        cells[] {
          ...,
          text[] {
            ${portableTextWithReferences}
          }
        }
      }
    },
  rows[] {
      ...,
      cells[] {
        ...,
        value[] {
          ${portableTextWithReferences}
        }
      }
    }
  }
`;
